import axios from 'axios';
import { LoginResponse, UserData } from '../types';
import { apiClient } from './apiClient';
import { ApiError } from '../error/error';

//**********************************************/
// ****  LOGIN
//**********************************************/
export const loginApiCall = async (email: string, password: string): Promise<any | null> => {
  try {

    const response = await apiClient.post<LoginResponse>('/api/admin/login', {
      email,
      password,
    });
   
    
    return response;
  } catch (error) {
    console.log('loginApiCall: ', error);
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error ||'Failed login', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};



export const logoutApiCall = async (): Promise<any | null> => {
  try {

    const response = await apiClient.post<LoginResponse>('/api/admin/logout');
   
  //console.log('loginApiCall: ', response);
  
    
    return response;
  } catch (error) {
  
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed logout', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
  
};